import { createSelector } from '@ngrx/store';
import { getTravelSearchState } from '../reducers';

export const getTravelSearchFormState = createSelector(getTravelSearchState, (state) => state?.travelSearchForm);
export const getFlightForm = createSelector(getTravelSearchFormState, (state) => state?.flight);
export const getHotelForm = createSelector(getTravelSearchFormState, (state) => state?.hotel);
export const getCarForm = createSelector(getTravelSearchFormState, (state) => state?.car);
export const getActivitiesForm = createSelector(getTravelSearchFormState, (state) => state?.activities);
